/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { AppDataExRes } from '../models/app-data-ex-res';
import { WorkGroupLabelRes } from '../models/work-group-label-res';

@Injectable({ providedIn: 'root' })
export class AppService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAppDataGet()` */
  static readonly ApiAppDataGetPath = '/api/app/data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAppDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAppDataGet$Response(
    params?: {
      config?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AppDataExRes>> {
    const rb = new RequestBuilder(this.rootUrl, AppService.ApiAppDataGetPath, 'get');
    if (params) {
      rb.query('config', params.config, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AppDataExRes>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAppDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAppDataGet(
    params?: {
      config?: string;
    },
    context?: HttpContext
  ): Observable<AppDataExRes> {
    return this.apiAppDataGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AppDataExRes>): AppDataExRes => r.body)
    );
  }

  /** Path part for operation `apiAppWorkgroupLabelGet()` */
  static readonly ApiAppWorkgroupLabelGetPath = '/api/app/workgroup-label';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAppWorkgroupLabelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAppWorkgroupLabelGet$Response(
    params?: {
      fkWorkGroupId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkGroupLabelRes>> {
    const rb = new RequestBuilder(this.rootUrl, AppService.ApiAppWorkgroupLabelGetPath, 'get');
    if (params) {
      rb.query('fkWorkGroupId', params.fkWorkGroupId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkGroupLabelRes>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAppWorkgroupLabelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAppWorkgroupLabelGet(
    params?: {
      fkWorkGroupId?: number;
    },
    context?: HttpContext
  ): Observable<WorkGroupLabelRes> {
    return this.apiAppWorkgroupLabelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkGroupLabelRes>): WorkGroupLabelRes => r.body)
    );
  }

}
